import { defineStore } from 'pinia';
import { ApiError, api, getToken, setToken, type User } from '@/api/client';

export const useAuth = defineStore('auth', {
  state: () => ({
    user: null as User | null,
    loading: false,
    /** Server bilan aloqa yo'q (demo rejim) */
    offline: false,
    checked: false,
  }),
  getters: {
    isAuthenticated: (s) => s.user !== null,
    role: (s) => s.user?.role ?? null,
    isTeacher: (s) => s.user?.role === 'teacher',
    isStudent: (s) => s.user?.role === 'student',
    isAdmin: (s) => s.user?.role === 'institution_admin' || s.user?.role === 'superadmin',
  },
  actions: {
    async bootstrap() {
      if (this.checked) return;
      this.checked = true;
      if (!getToken()) return;
      this.loading = true;
      try {
        this.user = await api<User>('GET', '/me');
        this.offline = false;
      } catch (e) {
        if (e instanceof ApiError && e.status === 0) this.offline = true;
        else setToken(null);
      } finally {
        this.loading = false;
      }
    },
    /** `login` — telefon raqami yoki e-mail */
    async login(login: string, password: string) {
      this.loading = true;
      try {
        const r = await api<{ token: string; user: User }>('POST', '/login', { login, password });
        setToken(r.token);
        this.user = r.user;
        this.offline = false;
      } finally {
        this.loading = false;
      }
    },
    /** Talaba ro'yxatdan o'tishi — muvaffaqiyatda darhol kiradi (token qaytadi) */
    async register(payload: {
      name: string;
      phone: string;
      email?: string;
      password: string;
      password_confirmation: string;
      institution_id: number;
      group_code?: string;
      verification_token?: string;
    }) {
      this.loading = true;
      try {
        const r = await api<{ token: string; user: User }>('POST', '/register', payload);
        setToken(r.token);
        this.user = r.user;
        this.offline = false;
        this.checked = true;
      } finally {
        this.loading = false;
      }
    },
    async logout() {
      try {
        await api('POST', '/logout');
      } catch {
        /* ignore */
      }
      setToken(null);
      this.user = null;
    },
  },
});
